import React from 'react';

const Footer1 = () => (
  <footer className="page-footer page-footer_navs text-center">
    <div className="container">
      <nav>
        <ul className="list-inline">
          <li>© 2015-{new Date().getFullYear()} TaskPay, Inc.</li>

          <li>
            <div>
              <a rel="nofollow" href="">
                Contacts
              </a>
            </div>
          </li>

          <li>
            <div>
              <a rel="nofollow" href="">
                Blog
              </a>
            </div>
          </li>

          <li>
            <div>
              <a rel="nofollow" href="">
                FAQ
              </a>
            </div>
          </li>

          <li>
            <div>
              <a rel="nofollow" href="">
                Affiliate program
              </a>
            </div>
          </li>

          <li>
            <div>
              <a rel="nofollow" href="">
                Rules
              </a>
            </div>
          </li>

          <li>
            <a href="">Site map</a>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
);

export default Footer1;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Footer/Footer1/Footer1.js